export const CHAT_MOBILE_SIDEBAR_BREAKPOINT = 900;
export const CHAT_TABLET_PORTRAIT_SIDEBAR_BREAKPOINT = 1024;
export const CHAT_MOBILE_NORMAL_MAX_WIDTH = 420;
export const CHAT_MOBILE_NORMAL_RATIO = 0.88;

const getViewportWidth = () =>
  typeof window === 'undefined'
    ? CHAT_MOBILE_NORMAL_MAX_WIDTH
    : window.innerWidth;

const isCoarsePointerViewport = () =>
  typeof window !== 'undefined' &&
  window.matchMedia('(pointer: coarse)').matches;

const isPortraitViewport = () =>
  typeof window !== 'undefined' &&
  (window.matchMedia('(orientation: portrait)').matches ||
    window.innerWidth <= window.innerHeight);

export const isMobileChatSidebarViewport = () => {
  const viewportWidth = getViewportWidth();
  if (viewportWidth <= CHAT_MOBILE_SIDEBAR_BREAKPOINT) {
    return true;
  }
  return (
    viewportWidth <= CHAT_TABLET_PORTRAIT_SIDEBAR_BREAKPOINT &&
    isCoarsePointerViewport() &&
    isPortraitViewport()
  );
};

export const getMobileChatFullWidth = () => getViewportWidth();

export const getMobileChatNormalWidth = () => {
  const viewportWidth = getViewportWidth();
  return Math.min(
    CHAT_MOBILE_NORMAL_MAX_WIDTH,
    Math.max(320, Math.round(viewportWidth * CHAT_MOBILE_NORMAL_RATIO))
  );
};

export const isMobileChatSidebarFullWidth = (
  width: number | null | undefined
) =>
  isMobileChatSidebarViewport() &&
  Math.abs((width ?? 0) - getMobileChatFullWidth()) <= 2;
